import { styled } from "sharedUI/styles";

export const AppPlanConfirmContainer = styled.div`
    width: 450px;
    margin: 0px 8px 0px 40px;

    .pad-bottom-large {
        margin-bottom: 24px;
    }

    > .group {
        .margin-bottom {
            margin-bottom: 8px;
        }

        .pad-right {
            margin-right: 8px;
        }

        .bold {
            font-weight: 700;
        }

        .med {
            font-size: 14px;
        }

        .sm {
            line-height: 18px;
            font-size: 13px;
        }

        .xsm {
            font-size: 12px;
        }

        .xxsm {
            line-height: 15px;
            font-size: 11px;
        }

        .pale {
            color: ${p => p.theme.upgradeModal.planConfirm.color};
        }

        .change {
            cursor: pointer;
        }

        .horiz {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &.no-stretch {
                justify-content: flex-start;
            }
        }

        > .section {
            margin-top: 8px;
            border-radius: 9px;
            border: 1px solid ${p => p.theme.n400};
            padding: 16px 20px;
        }
    }
`;
